export class FindUserRequestModel {
  user_id: number;
  search_text: string;
  phone_number: string;
  email: string;
  username: string;
  constructor(user_id: number = 0,search_text: string = "",phone_number: string = "",email: string = "",username: string = ""){
    this.user_id = user_id;
    this.search_text = search_text;
    this.phone_number = phone_number;
    this.email = email;
    this.username = username;
  }
  }
  